module.exports = __webpack_public_path__ + "img/31.3f4174c6.jpg";